import { useMutation, useQueryClient } from "@tanstack/react-query";

import { sendFeedback, SendFeedbackRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useSendFeedback = () => {
  const queryClient = useQueryClient();

  const openToast = useUIStore((state) => state.actions.toast.openToast);

  return useMutation({
    mutationFn: (body: SendFeedbackRequest) => {
      return sendFeedback(body);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["my-user"] });

      openToast({ variant: "success", message: "Your feedback has been sent!" });
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useSendFeedback };
